<app-title-section></app-title-section>

<div class="card p-1" style="margin-left: 15px; margin-right: 15px; min-height:100vh;">
    <ul class="nav nav-tabs m-0" style="border-bottom: 1px solid #eee;">
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/achat/avoir-fournisseur/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous', 'Tous')">
                Tous <app-tab-count [count]="getStatusCount('Tous')"></app-tab-count>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/achat/avoir-fournisseur/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon', 'Brouillon')">
                Brouillon <app-tab-count [count]="getStatusCount('Brouillon')"></app-tab-count>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/achat/avoir-fournisseur/non-utilise']" [class.active]="currentStatus === 'non-utilise'" (click)="filterByStatus('non-utilise', 'Non utilisé')">
                Non utilisé <app-tab-count [count]="getStatusCount('Non utilisé')"></app-tab-count>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/achat/avoir-fournisseur/partiellement-utilise']" [class.active]="currentStatus === 'partiellement-utilise'" (click)="filterByStatus('partiellement-utilise', 'Partiellement utilisé')">
                Partiellement utilisé <app-tab-count [count]="getStatusCount('Partiellement utilisé')"></app-tab-count>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/achat/avoir-fournisseur/utilise']" [class.active]="currentStatus === 'utilise'" (click)="filterByStatus('utilise', 'Utilisé')">
                Utilisé <app-tab-count [count]="getStatusCount('Utilisé')"></app-tab-count>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/achat/avoir-fournisseur/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule', 'Annulé')">
                Annulé <app-tab-count [count]="getStatusCount('Annulé')"></app-tab-count>
            </a>
        </li>
    </ul>
    <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
        <router-outlet></router-outlet>
    </div>
</div>
